import { useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import ConfirmationModal from './basics/ConfirmationModal';
import { PatternEditorContext } from '../contexts/PatternEditorContext';

const DirtyPatternModal = () => {
  const {
    dirtyPatternModalShown,
    dirtyPatternModalDeferred,
    setHasDirtyPattern,
  } = useContext(PatternEditorContext);

  const { dirty } = useFormikContext();

  useEffect(() => {
    setHasDirtyPattern(dirty);
    return () => setHasDirtyPattern(false);
  }, [dirty, setHasDirtyPattern]);

  return (
    <ConfirmationModal
      isOpen={dirtyPatternModalShown}
      title="Unsaved changes"
      actionDescriptionSentence="Pattern has unsaved changes."
      actionQuestion="Would you like to keep editing?"
      actionName="keep editing"
      cancelName="Discard changes"
      onCancel={dirtyPatternModalDeferred?.resolve} // Discard changes
      onConfirm={dirtyPatternModalDeferred?.reject} // Keep editing
    />
  );
};

export default DirtyPatternModal;
